module.exports = __webpack_public_path__ + "img/motorbikeOverview1Outline.09aea22b.svg";